module.exports = __webpack_public_path__ + "static/img/hync_er.872e56b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hync_er.png
// module id = gFC+
// module chunks = 1